import { Component, inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import {
  BricksIconComponent,
  BricksModalBodyComponent,
  BricksModalComponent,
  BricksModalFooterComponent,
  BricksModalHeaderComponent,
} from '@enbw_bricks/ui'
import { ProductionTechnology } from '../../../shared/models/production-technology.enum'

@Component({
  selector: 'app-multi-resource-popup',
  imports: [
    BricksModalFooterComponent,
    BricksModalBodyComponent,
    BricksModalComponent,
    BricksModalHeaderComponent,
    BricksIconComponent,
  ],
  templateUrl: './multi-resource-popup.component.html',
  styleUrl: './multi-resource-popup.component.scss',
})
export class MultiResourcePopupComponent {
  private readonly matDialogRef = inject<MatDialogRef<MultiResourcePopupComponent>>(MatDialogRef)
  private readonly data = inject<ProductionTechnology>(MAT_DIALOG_DATA)

  closeDialog() {
    this.matDialogRef.close()
  }

  get image(): string {
    const name = this.data == ProductionTechnology.Solar ? 'solar' : 'wind'
    return `assets/images/${name}-resource.svg`
  }
}
